import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]ETF专区列表
 */
export function eTFZoneListUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListFixedInvestmentItem> {
  return resource.postNoAuth('/lcToolBoxes/eTFZoneList', req, config);
}

/**
 * [No Auth]定投专区列表
 */
export function fixedInvestmentListUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<ApiResultListFixedInvestmentItem> {
  return resource.postNoAuth('/lcToolBoxes/fixedInvestmentList', req, config);
}

/**
 * [No Auth]理财工具箱列表
 */
export function productListUsingPOST(
  req: LcToolBoxesDto | void,
  config?: RequestConfig
): Promise<ApiResultLcToolBoxesParam> {
  return resource.postNoAuth('/lcToolBoxes/productList', req, config);
}

/**
 * [No Auth]根据tab获取相应专区列表
 */
export function getZoneListByTabUsingPOST(
  req: ZoneTabDto | void,
  config?: RequestConfig
): Promise<ApiResultListFixedInvestmentItem> {
  return resource.postNoAuth('/lcToolBoxes/zoneListByTab', req, config);
}
